export default __webpack_public_path__ + "static/media/choose3.b182d2c8.svg";